<template>
    <div class="relative max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="max-w-lg mx-auto rounded-lg shadow-lg overflow-hidden lg:max-w-none lg:flex">
            <div class="bg-white px-6 py-8 lg:flex-shrink-1 lg:p-12">
                <div class="flex flex-col lg:flex-row items-center">
                    <div class="flex-1 border-t-2 border-grey-light mr-4"></div>

                    <p class="pr-4 bg-white text-xl font-semibold text-black mb-4 lg:mb-0">I want to monitor up to</p>

                    <div class="pr-4 mb-4 lg:mb-0">
                        <div class="max-w-xs shadow-sm">
                            <div class="relative">
                                <select v-model="monitors" id="monitors" class="block form-select pr-10 font-bold text-xl">
                                    <option>5</option>
                                    <option>10</option>
                                    <option>25</option>
                                    <option>50</option>
                                    <option>100</option>
                                    <option>250</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <p class="pr-4 bg-white text-xl font-semibold text-black mb-4 lg:mb-0">websites</p>

                    <div class="flex-1 border-t-2 border-grey-light"></div>
                </div>

                <p class="mt-6 text-base leading-6 text-gray-500">
                    Do you have more than 250 websites that need monitoring? We can setup a custom plan for your specific use case.
                    <a :href="email" class="font-medium text-blue-600 hover:text-blue-500 focus:outline-none focus:underline transition ease-in-out duration-150"
                        >Get in touch with us!</a
                    >
                </p>
                <div class="mt-8">
                    <div class="flex items-center">
                        <h4 class="flex-shrink-0 pr-4 bg-white text-sm leading-5 tracking-wider font-semibold uppercase text-blue-600">All features included in all plans</h4>
                        <div class="flex-1 border-t-2 border-gray-200"></div>
                    </div>
                    <ul class="mt-8 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:gap-y-2">
                        <li class="mt-2 flex items-start lg:col-span-1 lg:mt-0">
                            <div class="flex-shrink-0">
                                <svg class="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                                    <path
                                        fill-rule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            </div>
                            <p class="ml-3 text-sm leading-5 text-gray-700">No hidden fees</p>
                        </li>
                        <li class="mt-2 flex items-start lg:col-span-1 lg:mt-0">
                            <div class="flex-shrink-0">
                                <svg class="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                                    <path
                                        fill-rule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            </div>
                            <p class="ml-3 text-sm leading-5 text-gray-700">All features</p>
                        </li>
                        <li class="mt-2 flex items-start lg:col-span-1 lg:mt-0">
                            <div class="flex-shrink-0">
                                <svg class="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                                    <path
                                        fill-rule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            </div>
                            <p class="ml-3 text-sm leading-5 text-gray-700">30 seconds uptime monitoring</p>
                        </li>
                        <li class="mt-2 flex items-start lg:col-span-1 lg:mt-0">
                            <div class="flex-shrink-0">
                                <svg class="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                                    <path
                                        fill-rule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            </div>
                            <p class="ml-3 text-sm leading-5 text-gray-700">SSL certificate health monitoring</p>
                        </li>
                        <li class="mt-2 flex items-start lg:col-span-1 lg:mt-0">
                            <div class="flex-shrink-0">
                                <svg class="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                                    <path
                                        fill-rule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            </div>
                            <p class="ml-3 text-sm leading-5 text-gray-700">Unlimited users</p>
                        </li>
                        <li class="mt-2 flex items-start lg:col-span-1 lg:mt-0">
                            <div class="flex-shrink-0">
                                <svg class="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                                    <path
                                        fill-rule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            </div>
                            <p class="ml-3 text-sm leading-5 text-gray-700">Powerful notifications</p>
                        </li>
                        <li class="mt-2 flex items-start lg:col-span-1 lg:mt-0">
                            <div class="flex-shrink-0">
                                <svg class="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                                    <path
                                        fill-rule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            </div>
                            <p class="ml-3 text-sm leading-5 text-gray-700">Developer API</p>
                        </li>
                        <li class="mt-2 flex items-start lg:col-span-1 lg:mt-0">
                            <div class="flex-shrink-0">
                                <svg class="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                                    <path
                                        fill-rule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                        clip-rule="evenodd"
                                    />
                                </svg>
                            </div>
                            <p class="ml-3 text-sm leading-5 text-gray-700">Public/Private Status Page with Custom Domains</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="py-8 px-6 text-center bg-gray-50 lg:flex-shrink-0 lg:flex lg:flex-col lg:justify-center lg:p-12">
                <p class="text-lg leading-6 font-medium text-gray-900">Your price will be</p>
                <div class="mt-4 flex items-center justify-center text-5xl leading-none font-extrabold text-gray-900">
                    <span> {{ price }}&euro; </span>
                    <div class="text-left">
                        <div class="ml-3 text-xl leading-5 font-medium text-gray-500">per</div>
                        <div class="ml-3 text-xl leading-5 font-normal text-gray-500">month</div>
                    </div>
                </div>

                <p class="mt-4 text-sm leading-5">
                    <span class="font-medium text-gray-500">
                        You always start with a 14 days trial.<br />
                        You can upgrade at any time.
                    </span>
                </p>

                <div class="mt-6">
                    <div class="rounded-md shadow">
                        <a
                            href="/signup"
                            class="flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-500 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out"
                        >
                            Start monitoring
                        </a>
                    </div>
                </div>

                <div class="mt-3 text-xs text-gray-400">
                    <div class="">Prices in EUR, excl. VAT</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['email'],

    data() {
        return {
            monitors: 5,
            pricing: {
                5: 6,
                10: 12,
                25: 30,
                50: 50,
                100: 90,
                250: 185,
            },
        }
    },

    computed: {
        price() {
            return this.pricing[this.monitors]
        },
    },
}
</script>
